/**
 * P3 · Communications lens — standalone route (STAFF-authenticated).
 *
 * A THIN full-page view of the shared <LensThread/>. Route-driven target:
 *   /comms/contact/:contactId  → Person lens (filter { contactId })
 *   /comms/project/:projectId  → Project lens (filter { projectId })
 *
 * Same live sources, same merged thread, same real Team-Inbox <Thread/> +
 * <Composer/> as the contact-record tab and the project page — sliced two ways.
 * Rendered WITHOUT AppShell (App.tsx), so this owns the full viewport: a slim
 * header + the lens filling the rest. The reused `.ti-canvas` is the sole
 * scroller (single-scroll rule).
 */
import { Link, useParams } from 'react-router-dom';
import LensThread from '../features/teaminbox/lens/LensThread';
import './CommsLens.css';

export default function CommsLens() {
  const { contactId, projectId } = useParams<{ contactId?: string; projectId?: string }>();
  return (
    <div className="commslens-page">
      <header className="commslens-head">
        <Link to={projectId ? '/projects' : '/contacts'} className="commslens-back">
          ← Back
        </Link>
        <div>
          <h1 className="commslens-title">Communications</h1>
          <p className="commslens-sub">
            {projectId ? `Project ${projectId}` : `Contact ${contactId ?? ''}`} —
            WhatsApp, email and internal notes in one live thread.
          </p>
        </div>
      </header>
      <main className="commslens-body">
        {contactId ? (
          <LensThread mode="contact" contactId={contactId} />
        ) : projectId ? (
          <LensThread mode="project" projectId={projectId} />
        ) : (
          <p className="commslens-sub">No contact or project in the URL.</p>
        )}
      </main>
    </div>
  );
}
